module.exports = {
	"lan": [
		"cn",
		"en",
		"fr",
		"fa"
	],
	"default": "cn",
	"data": {
		"title": {
			"cn": "積德消業",
			"en": "積德消業",
			"fr": "T E T R I S",
			"fa": "خانه سازی"
		},
		"titleCenter": {
			"cn": "游戲<br/>開始",
			"en": "游戲<br/>開始",
			"fr": "游戲<br/>開始",
			"fa": "游戲<br/>開始"
		},
		"point": {
			"cn": "行善<small>SCORE</small>",
			"en": "行善",
			"fr": "Score",
			"fa": "امتیاز"
		},
		"highestScore": {
			"cn": "頂点<small>PEAK</small>",
			"en": "頂点",
			"fr": "Max",
			"fa": "حداکثر"
		},
		"lastRound": {
			"cn": "前世<small>LAST</small>",
			"en": "前世",
			"fr": "Dernier Tour",
			"fa": "آخرین دور"
		},
		"cleans": {
			"cn": "消業<small>CLEAR</small>",
			"en": "消業",
			"fr": "Lignes",
			"fa": "پاک کرد"
		},
		"level": {
			"cn": "境界<small>LEVEL</small>",
			"en": "境界",
			"fr": "Difficulté",
			"fa": "سطح"
		},
		"startLine": {
			"cn": "開始<small>START</small>",
			"en": "開始",
			"fr": "Ligne Départ",
			"fa": "خط شروع"
		},
		"next": {
			"cn": "来者<small>NEXT</small>",
			"en": "来者",
			"fr": "Prochain",
			"fa": "بعدی"
		},
		"pause": {
			"cn": "停<small>PAUSE</small>",
			"en": "Pause",
			"fr": "Pause",
			"fa": "مکث"
		},
		"rest": {
			"cn": "息<small>REST</small>",
			"en": "Rest",
			"fr": "Repos",
			"fa": "استراحت"
		},
		"sound": {
			"cn": "音<small>SOUND</small>",
			"en": "Sound",
			"fr": "Sonore",
			"fa": "صدا"
		},
		"reset": {
			"cn": "悔<small>RESET</small>",
			"en": "Reset",
			"fr": "Réinitialiser",
			"fa": "ریست"
		},
		"rotation": {
			"cn": "转<small>ROTATE</small>",
			"en": "Turn",
			"fr": "Rotation",
			"fa": "چرخش"
		},
		"left": {
			"cn": "左<small>LEFT</small>",
			"en": "Left",
			"fr": "Gauche",
			"fa": "چپ"
		},
		"right": {
			"cn": "右<small>RIGHT</small>",
			"en": "Right",
			"fr": "Droite",
			"fa": "راست"
		},
		"down": {
			"cn": "落<small>DOWN</small>",
			"en": "Drop",
			"fr": "Bas",
			"fa": "پایین"
		},
		"drop": {
			"cn": "坠<small>DROP</small>",
			"en": "Fall",
			"fr": "Tomber",
			"fa": "سقوط"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n.json
// module id = 183
// module chunks = 1